import { render, staticRenderFns } from "./ManualSearch.vue?vue&type=template&id=8435a31e&scoped=true&"
import script from "./ManualSearch.vue?vue&type=script&lang=ts&"
export * from "./ManualSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ManualSearch.vue?vue&type=style&index=0&id=8435a31e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8435a31e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Development/vGroup/mat-selector-shopify-widget/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCardActions,VCardText,VFlex,VForm,VLayout})
